// extracted by mini-css-extract-plugin
export var container = "FrequentlyAskedQuestions-module__container___RwXHT";
export var need = "FrequentlyAskedQuestions-module__need___at9db";
export var questions = "FrequentlyAskedQuestions-module__questions___i7BXQ";